import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityFinancialInfoProps {
  community_id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityFinancialInfo = async (ID: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/financial-info`);

const useGetCommunityFinancialInfo = ({
  community_id,
  queryParams,
}: UseGetCommunityFinancialInfoProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-financial-info", community_id],
    queryFn: () => getCommunityFinancialInfo(community_id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCommunityFinancialInfo;
